import { useEffect } from 'react';
import { useGetOne } from 'react-admin';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Publisher } from '../../customRoutes/authentication/types';
import { Offer } from '../../resources/offers/types';
import { replacePublisherIdInPath } from '../../utils';

export const useOfferPublisherSync = (
  publishers: Publisher[],
  currentPublisherId?: string
) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { offerId: offerIdFromUrl } = useParams();

  const { data: offerFromUrl, isSuccess } = useGetOne<Offer>(
    'offers',
    { id: offerIdFromUrl },
    { enabled: !!offerIdFromUrl }
  );

  useEffect(() => {
    if (isSuccess && offerFromUrl && publishers.length > 0) {
      if (offerFromUrl.publisher_id !== currentPublisherId) {
        const correctPublisher = publishers.find(
          p => p.id === offerFromUrl.publisher_id
        );
        if (correctPublisher) {
          navigate(
            replacePublisherIdInPath(location.pathname, correctPublisher.id)
          );
        }
      }
    }
  }, [
    isSuccess,
    offerFromUrl,
    publishers,
    currentPublisherId,
    navigate,
    location.pathname,
  ]);
};
